import { render, staticRenderFns } from "./ChannelDistributionSearchPage.vue?vue&type=template&id=7228397c&scoped=true&"
import script from "./ChannelDistributionSearchPage.vue?vue&type=script&lang=ts&"
export * from "./ChannelDistributionSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDistributionSearchPage.vue?vue&type=style&index=0&id=7228397c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228397c",
  null
  
)

export default component.exports